import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signIn } from '../../firebase/auth';
import './Sidebar.css';
import searchIcon from '../../assets/search.svg';
import PropTypes from 'prop-types';
import facilities from '../../config/facilities.json';
import { Autocomplete } from '@mui/material';
import { useFacility } from '../../context/FacilityContext';

function Sidebar({ isHomePage, facilityId }) {
  let navigate = useNavigate();

  const { _, setFacilityId } = useFacility();

  const [staffEmail, setStaffEmail] = useState('');
  const [staffPassword, setStaffPassword] = useState('');

  const [value, setValue] = useState(null);

  const facilitySearchChange = (newValue) => {
    if (newValue != null) {
      navigate(`/${newValue.value}`);
    }
  };

  const handleSignIn = async (e) => {
    e.preventDefault();
    try {
      const user = await signIn(staffEmail, staffPassword);
      setFacilityId(facilityId);
      navigate('/verify');
    } catch (error) {
      alert('Incorrect email or password!');
    }
  };

  const facilityOptions = facilities.map((facility) => ({
    label: facility.name,
    value: facility.id,
  }));

  return (
    <div className="pageSidebar">
      <div className="staffLoginContainer">
        <button
          className="sidebarSignInButton"
          onClick={(e) => {
            navigate('/login');
          }}
        >
          Sign In
        </button>
      </div>

      <div className="sidebarSearchContainer">
        <p>
          {isHomePage
            ? 'Looking for another facility?'
            : 'Looking for a specific facility?'}
        </p>
        <div className="searchContainer">
          <img src={searchIcon} alt="Search" />
          {/* <input type="text" name="Search" placeholder="Search all facilities" /> */}
          <Autocomplete
            id="facility-search"
            options={facilityOptions}
            value={value}
            onChange={(_, newValue) => {
              setValue(newValue);
              facilitySearchChange(newValue);
            }}
            isOptionEqualToValue={(option, value) =>
              option.value === value.value
            }
            renderInput={(params) => (
              <div ref={params.InputProps.ref}>
                <input
                  type="text"
                  name="Search"
                  placeholder="Search all facilities"
                  {...params.inputProps}
                />
              </div>
            )}
          />
        </div>
      </div>
    </div>
  );
}

Sidebar.propTypes = {
  isHomePage: PropTypes.bool,
  facilityId: PropTypes.string,
};
export default Sidebar;
